import { useContext } from "react";

import { useTranslation } from "react-i18next";
import { Link, useMatch } from "react-router";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipOptional
} from "components/DesignComponents/Tooltips";
import RoutesContext from "context/routes/routesContext";

import { LinkItemProps } from "./types";

const LinkItem = ({ name, icon, link }: LinkItemProps) => {
    const { gray100, gray200, gray300, gray700 } = colors;

    const { isDesktopDrawerOpen, isMobileDrawerOpen } =
        useContext(RoutesContext);

    const { t } = useTranslation();

    const isActive = useMatch(link) !== null;

    return (
        <li>
            <TooltipOptional
                isHidden={isDesktopDrawerOpen || isMobileDrawerOpen}
                title={t(`General##${name}`)}
                placement={TOOLTIP_PLACEMENT.Right}
                disableTouchListener
            >
                <Link
                    to={link}
                    id={name}
                    className="navigation-item"
                    onClick={e => isActive && e.preventDefault()}
                    css={css({
                        color: gray700,
                        backgroundColor: isActive ? gray200 : "transparent",

                        "& > svg": {
                            color: gray700,
                            flexShrink: 0
                        },

                        "& > span": {
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "20px",
                            letterSpacing: "0.1px",
                            marginLeft: "8px",
                            whiteSpace: "nowrap",
                            color: gray700
                        },

                        "&:hover": {
                            backgroundColor: isActive ? gray300 : gray100
                        },

                        "&:active": {
                            backgroundColor: isActive ? gray300 : gray200
                        }
                    })}
                >
                    {icon} <span>{t(`General##${name}`)}</span>
                </Link>
            </TooltipOptional>
        </li>
    );
};

export default LinkItem;
